export default __webpack_public_path__ + "styles/LabeledControl.0e99b4a7cf7979c841684f56daae2fcb.css";